import { postCommonConfigGetNoticeDetail } from '@/services/yizhe-web/gonggongfenlei';
import { useModel } from '@umijs/max';
import { Modal } from 'antd';
import { useImperativeHandle } from 'react';
const NoticeDetail: React.FC<any> = (props: any) => {
  const { initialState, setInitialState } = useModel('@@initialState');
  const getDetailData = async () => {
    const { code, data } = await postCommonConfigGetNoticeDetail({
      notice_id: props?.data?.notice_id,
    });
    if (code === '200') {
      if (initialState && initialState.fetchRedNum) {
        initialState?.fetchRedNum().then((res) => {
          setInitialState((s) => ({ ...s, redNum: res }));
        });
      }
      Modal.success({
        icon: null,
        width: 1100,
        title: '消息详情',
        autoFocusButton: null,
        className: 'modalform-fixed',
        content: (
          <>
            <div
              dangerouslySetInnerHTML={{ __html: data?.notice_content }}
              className="modal-notice-detail"
            />
          </>
        ),
        closable: true,
        okText: '关闭',
        okButtonProps: { type: 'default' },
        onCancel: () => {
          props.update();
        },
      });
    }
  };
  useImperativeHandle(props.cRef, () => ({
    getDetailData,
  }));
  return (
    <div>
      {props.btnText ? (
        <span
          key="view"
          onClick={() => {
            getDetailData();
          }}
        >
          {props.btnText}
        </span>
      ) : (
        <a
          key="view"
          onClick={() => {
            getDetailData();
          }}
        >
          详情
        </a>
      )}
    </div>
  );
};
export default NoticeDetail;
